import { IResponseCompanyConnection, IResponseCompanyConnectRoles } from "@services/company.interface";

/**
 * Checks if the user has the permission to perform the action
 * @param companyConnection User's company connection
 * @param permission the permission to check
 * @returns Boolean value indicating if the permission is allowed
 */
export function isPermissionAllowed(companyConnection: IResponseCompanyConnection, permission: string): boolean {
  if (!companyConnection?.company_connection_user_roles) return false;

  // a user can have multiple roles, so we need to check all of them
  const allPermissions: string[] = companyConnection.company_connection_user_roles
    .flatMap((role: IResponseCompanyConnectRoles) => role.company_connection_user_role.user_role.permissions);

  return allPermissions.includes(permission);
}